<template>
    <div class="promotional-banner">
        <a
                href="#!"
                class="alert"
                @click.prevent="clickHandler"
        >
            <img
                    :src="promotionalBanner.public_banner_image_url"
                    class="image"
                    alt="Promotional banner"
            />
            <img
                    :src="promotionalBanner.public_banner_responsive_image_url"
                    class="responsive-image"
                    alt="Promotional banner"
            />
        </a>
    </div>
</template>
<script>
    import Spinner from "./Spinner";
    import EventBus from '../eventbus';

    export default {
        components: {
            Spinner,
        },
        props: {
            promotionalBanner: {
                type: Object,
                required: true,
            }
        },
        data(){
            return {

            }
        },
        methods: {
            clickHandler(){
                switch(this.promotionalBanner.action_type){
                    case 'promotional_code':
                        this.$router.push({name: 'purchase.subscription', query: {code: this.promotionalBanner.action_value}});
                        break;

                    case 'url':
                        location.href = this.promotionalBanner.action_value;
                        break;

                    case 'membership_plan_list':
                        this.$router.push({name: 'purchase.subscription'});
                        break;

                    default: throw new Error(`Unknown action type: ${this.promotionalBanner.action_type}`);
                }
            }
        },
    }
</script>
<style scoped lang="scss">
    .promotional-banner{

        color: #ffffff;


        img{
            width: 100%;
            height: auto;
        }

        .image{
            display: block;
        }

        .responsive-image{
            display: none;
        }

        @media(max-width: 768px){
            .image{
                display: none;
            }

            .responsive-image{
                display: block;
            }
        }
    }
</style>